<template lang="pug">
  #app
    bw-header
    bw-wavey-top        
    router-view
    bw-footer
</template>

<script>
import BwHeader from "@/components/header/BwHeader";
import BwFooter from "@/components/footer/BwFooter";
import BwWaveyTop from "@/components/shared/BwWaveyTop";
export default {
  components: {
    BwHeader,
    BwFooter,
    BwWaveyTop
  }
};
</script>

<style lang="stylus">
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  //text-align center
  //color #2c3e50
  //margin-top 60px
  //padding-top: var(--header-height)
  padding-top: var(--header-height)
  padding-bottom: var(--footer-height)
  position: relative
  height: 100%
  width: 100%
  overflow-x: hidden
  overflow-y: hidden
.wavey-top
  width: 100%
  position: absolute
  bottom: 200px
  left: 0
  right: 0
</style>
